<script setup lang="ts">
import theme from './theme'

const { sessionData } = useSessionData()

sessionData.ignoreRouterLink = true
sessionData.refreshOnLocaleChange = true

// const headerPlaceholder = document.getElementById('base-app-header-placeholder')
// if (headerPlaceholder) headerPlaceholder.style.display = 'none'
// const sidebarPlaceholder = document.getElementById('base-app-sidebar-placeholder')
// if (sidebarPlaceholder) sidebarPlaceholder.style.display = 'none'

const { isHomePage } = useIsHomePage()
const { isWidget } = useWidgetSettings()
useLocale() // configure global locale watcher

const isMounted = ref(false)
onMounted(() => isMounted.value = true)
const loading = computed(() => !isMounted.value || isHomePage.value === undefined)
</script>

<template>
  <DSLoadingWrapper :loading="loading">
    <Teleport to="#base-app-header">
      <AppHeader v-if="!isWidget" />
    </Teleport>

    <Teleport to="#base-app-banners-above-nav-menu">
      <AppBannersAboveNavMenu />
    </Teleport>

    <Teleport to="#base-app-menu">
      <AppNavMenu v-if="!isHomePage" />
      <AppMobilePageHeader
        v-if="!isHomePage"
        class="my-4"
      />
    </Teleport>

    <Teleport to="#base-app-banners-below-nav-menu">
      <AppBannersBelowNavMenu v-if="!isHomePage" />
    </Teleport>

    <Teleport to="#base-app-footer">
      <AppFooter v-if="!isWidget" />
    </Teleport>

    <Teleport to="#base-app-notifications">
      <DSNotifier class="fixed bottom-10 right-10 w-300px" />
    </Teleport>

    <ProviderThemeCssVariables />
    <DSThemeProvider :theme="theme" />
    <AppAlerts />
    <AppApiErrors />

    <Teleport to="#base-app-mobile-menu">
      <AppNavMenuMobileDrawer v-if="!isHomePage" />
    </Teleport>

  <!-- <div class="min-h-100vh flex flex-col flex-gap-y-4 bg-[--theme-color-underlay-background]">
    <div class="grow">
    </div>
  </div> -->
  </DSLoadingWrapper>
</template>
